import { render, staticRenderFns } from "./BulkMoveDrawer.vue?vue&type=template&id=5d2b8845&scoped=true&"
import script from "./BulkMoveDrawer.vue?vue&type=script&lang=js&"
export * from "./BulkMoveDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BulkMoveDrawer.vue?vue&type=style&index=0&id=5d2b8845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b8845",
  null
  
)

export default component.exports